<template>
    <section class="formatter">
        <div class="d-flex gap-5">
            <div class="editor-row customize-editor-minimize">
                <div class="editor-row-title">Subtracting Value</div>
                <TiptapEditor
                    placeholder="Subtract Value or pick from a variable"
                    :show-attributes="true"
                    v-model="clone.sub.value"
                    :show-emoji="false"
                    automation-mode
                />
            </div>
            <div class="editor-row customize-editor-minimize">
                <div class="editor-row-title">Subtracting Unit Type</div>
                <CustomPicker v-model="clone.sub.unit" :items="unitTypes" idKey="id" labelKey="label" />
            </div>
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.sub.fromFormat" title="From Format" />
            <FormatPickerInput v-model="clone.sub.toFormat" title="To Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.sub.fromLocale" title="From Locale" />
            <LocalePickerInput v-model="clone.sub.toLocale" title="To Locale" />
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../../../components/pickers/CustomPicker.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";

const log = log2("DateSub.vue");
export default {
    name: "DateSub.vue",
    components: { CustomPicker, TiptapEditor, FormatPickerInput, LocalePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.sub", //date.add,date.sub,date.format,date.compare,startOf,endOf,date.diff
            inputs: [""],
            add: {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            },
            sub: {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            },
            format: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                toTimezone: "UTC",
                fromTimezone: "UTC",
                fromLocale: "en",
                toLocale: "en",
            },
            compare: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                checkPart: ["year", "month", "day", "hour", "minute", "second"],
            },
            startOf: {
                unit: "day",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                timezone: "UTC",
            },
            endOf: {
                unit: "day",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                timezone: "UTC",
            },
            diff: {
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                unit: "days",
            },
        };
        if (!clone.sub) {
            clone.sub = {
                value: "1",
                unit: "days",
                fromFormat: "YYYY-MM-DD",
                toFormat: "YYYY-MM-DD",
                fromLocale: "en",
                toLocale: "en",
            };
        }
        return {
            clone,
            unitTypes: [
                {
                    id: "days",
                    label: "Days",
                    description: "Subtract days to a date",
                },
                {
                    id: "months",
                    label: "Months",
                    description: "Subtract months to a date",
                },
                {
                    id: "years",
                    label: "Years",
                    description: "Subtract years to a date",
                },
                {
                    id: "hours",
                    label: "Hours",
                    description: "Subtract hours to a date",
                },
                {
                    id: "minutes",
                    label: "Minutes",
                    description: "Subtract minutes to a date",
                },
                {
                    id: "seconds",
                    label: "Seconds",
                    description: "Subtract seconds to a date",
                },
            ],
        };
    },
    methods: {},
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section {
            width: 100%;
        }

        .locale-picker-section {
            width: 100%;
        }
    }
}
</style>
